globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.DisconnectPlatform = (function(superClass) {

  utils.extend(DisconnectPlatform, superClass);

  function DisconnectPlatform() {
    return DisconnectPlatform.__super__.constructor.apply(this, arguments);
  }

  $.extend(DisconnectPlatform.prototype, {
    init: function() {
      var modal = this;

      modal.$html.on('change', 'input', function(){
        modal.$html.find('.and-delete').toggleClass('hidden');
      });

      return DisconnectPlatform.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data, successMsg) {
      if (data.response) {
        window.location.reload();
      }
    },
  });

  return DisconnectPlatform;

})(appCustomerSpace.Modal);
